module.exports = __webpack_public_path__ + "img/learnmore182x.8907b608.png";